import React from 'react'
import './P2.css';
import { useDispatch } from 'react-redux';
import { addToCart } from '../../store/cartSlice';


const P2 = ({ Id, Cover, Price, Name, About, Stars }) => {

  const dispatch = useDispatch();



  return (
    <>
              <div className='Chefbox' >
                <div className="chefPic">
                  <img src={Cover} alt='' />
                  <span>${Price}</span>
                </div>
                <div className="chefText">
                  <div className="chefTextinner">
                    <h2>{Name}</h2>
                    <p>{About}</p>
                    <button className='chefBtn' onClick={() => dispatch(addToCart({Id, Cover, Price, Name, About, Stars}))}>
                      Add To Cart
                    </button>
                  </div>
                </div>
              </div> 
    </>
  )
}

export default P2
